// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge-primary {\n  color: white !important;\n  background-color: #37514d !important;\n}\n.tab-selected {\n  color: #19191c !important;\n}\n.tab-unselected {\n  color: #828282 !important;\n}\n", ""]);
// Exports
module.exports = exports;
